module.exports = __webpack_public_path__ + "static/8-dcf8c0eb3e352405244996d9e9118865.jpg";